<template>
  <div>     
    <div class="header-resultado">
        <div class="nfe">
            Chave NFe/NFCe	
        </div>
        <div class="dest">
            Destinatário	
        </div>
        <div class="produto" :style="{'max-width': optante ? '300px' : '240px'}">
            Produto	
        </div>
        <div class="ncm" style="max-width: 75px;"> NCM </div>
        <div class="ncm"  :style="{'max-width': optante ? '130px' : '75px'}">
            EXTIPI 
        </div>
        <div class="revisao" :style="{'max-width': optante ? '130px' : '100px'}">
            Revisão	
        </div>
        <div class="cfop" :style="{'max-width': optante ? '130px' : '55px','border-right': optante ? 'none':''}">CFOP</div>
        <div class="pis" v-if="!optante" >PIS</div>
        <div class="cofins" v-if="!optante">Cofins</div>
    </div>  
    <div class="ronaldo">    
     <div v-for="(n,i) in dados" :key="i" style="margin-bottom:12px;">
        <div class="body-resultado" >
            <div class="nfe" v-html="higChave(n.chave.substring(3,100),1)">            
            </div>
            <div  class="dest" v-html="higDest(n.dest,2)">            
            </div>
            <div  class="produto" v-html="higPro(n.produto,3)" :style="{'max-width': optante ? '300px' : '240px'}">       
                       
            </div>
            <div class="ncm" v-html="higNcm(n.ncm,4)" :style="{'max-width': optante ? '130px' : '75px'}"></div>
            <div class="ncm"  :style="{'max-width': optante ? '130px' : '75px'}">{{n.extipi == null ? '-' : n.extipi}}</div>
            <div class="revisao" :style="{'max-width': optante ? '130px' : '100px'}">
                <div class="monofasico" v-if="n.revisao == 1">
                    Monofásico
                </div>
                <div class="aliquotaZero" v-else-if="n.revisao == 2">
                    Alíquota Zero
                </div>
                <div class="tributario" v-else-if="n.revisao == 3">
                    Subst. tributária
                </div>
            </div>
            <div class="cfop" :style="{'max-width': optante ? '130px' : '55px', 'border-right': optante ? 'none':''}">{{n.cfop}}</div>
            <div class="pis" v-if="!optante"> {{n.pis !=null  & n.pis != '' ? 'R$'+parseFloat(n.pis).toLocaleString() : '-'}}</div>
            <div  class="cofins" v-if="!optante">{{n.cofins !=null & n.pis != '' ?  'R$'+parseFloat(n.cofins).toLocaleString() : '-'}}</div>
        </div>
        <div v-if="n.obs" style="padding-left: 10px;font-size: 12px;background: #FFAA21;border-radius: 0px 0px 5px 5px;color: #000;font-weight: bold;">
            {{n.obs}}
        </div>
    </div>
    </div>   
    <div class="footer-resultado">
        <div class="nfe" style="border-right: 1px solid #AF3437;">            
        </div>
        <div class="dest"  style="border-right: 1px solid #AF3437;">            	
        </div>
        <div class="produto"  style="border-right: 1px solid #AF3437;">            	
        </div>
        <div class="ncm"  style="border-right: 1px solid #AF3437;">           	
        </div>
        <div class="revisao"  style="border-right: 1px solid #AF3437;">            	
        </div>
        <div class="cfop"  style="border-right: 1px solid #AF3437;" v-if="!optante">Total: </div>
        <div class="pis" v-if="!optante">R$ {{totalPisA.toLocaleString()}}</div>
        <div class="cofins" v-if="!optante">R$ {{totalCofinsA.toLocaleString()}}</div>
    </div>
  </div>
</template>

<script>
export default {    
    props: {
        optante:Boolean,
        dados: Array,
        totalCofinsA: Number,
        totalPisA: Number,
        texto: Text,
        atualPesquisar:Text
    },   
    data(){
        return{
            pis:false,           
        }
    },
    methods:{
        higPro(txt){
            if(this.texto != '' && this.atualPesquisar == 'Produto'){
                return txt.replace(new RegExp(this.texto,'gi'), '<span class="hig">$&</span>')
            }else{
                return txt
            }            
        },
         higDest(txt){
            if(this.texto != '' && this.atualPesquisar == 'Destinatário'){
                return txt.replace(new RegExp(this.texto,'gi'), '<span class="hig">$&</span>')
            }else{
                return txt
            }            
        },
        higChave(txt){
            if(this.texto != '' && this.atualPesquisar == 'NFe/NFCe'){
                return txt.replace(new RegExp(this.texto,'gi'), '<span class="hig">$&</span>')
            }else{
                return txt
            }            
        },
        higNcm(txt){
            if(this.texto != '' && this.atualPesquisar == 'NCM'){
                return txt.replace(new RegExp(this.texto,'gi'), '<span class="hig">$&</span>')
            }else{
                return txt
            }            
        }
    }
}
</script>

<style>
.tributario{
    background: #10b5cf;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    color: #fff;
}
.hig{
    color:rgb(255, 0, 0) !important;
    font-weight: bold;
}
.ronaldo{
    border: 1px solid rgb(175, 52, 55);
    padding: 5px;
    box-shadow: rgb(0 0 0 / 25%) 0px 4px 4px;
    background: #fff;   
}
.aliquotaZero{
    background: rgb(65, 130, 206);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    color: #fff;
}
.monofasico{
    background: #393842;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    color: #fff;
}
.footer-resultado{
    padding-right: 5px;
    padding-left: 5px;
    border: 1px solid rgb(175, 52, 55);
    display: flex;
    border-top: 0;
    width: 100%;
    background: #AF3437;
    color: #FAF8FA;
    font-weight: bold;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-bottom: 0;
     font-size: 12px;
}
.header-resultado{
    padding-right: 5px;
    padding-left: 5px;
    border: 1px solid rgb(175, 52, 55);
    display: flex;
    border-top: 0;
    width: 100%;
    background: #AF3437;
    color: #FAF8FA;
    font-weight: bold;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 0;
}
.body-resultado:hover{
        background: #b8b8b8;;
}
.body-resultado{
    display: flex;
    width: 100%;
    background: #EEEEEE;;
    border-radius: 5px;  
    font-size: 12px;
    color:#393842;  
     border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
.nfe{        
    min-width: 310px;
    width: 100%;  
    max-width: 310px;
    padding: 15px 10px;
    border-right:1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dest{
    max-width: 250px;
    width: 100%;
     padding: 10px 10px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 120px;
    overflow: auto;
}
.ncm{
    max-width: 75px;
    width: 100%;
     padding: 15px 10px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    min-width: 75px;
}
.produto{
    max-width: 240px;
    width: 100%;
     padding: 15px 5px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 111px;
    overflow: auto;
}
.revisao{
    max-width: 100px;
    width: 100%;
    text-align:center;
     padding: 15px 5px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
}
.cfop{
    max-width: 55px;
    width: 100%;
    text-align:center;
     padding: 15px 5px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    min-width: 55px;
}
.pis{
    max-width: 100px;
    width: 100%;
    text-align:center;
     padding: 15px 5px;
     border-right:1px solid #fff;
     display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
}
.cofins{
    max-width: 100px;
    width: 100%;
    text-align:center;
    padding: 15px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    
}
</style>